export const OPTIONS_REQUEST = 'OPTIONS_REQUEST';
export const OPTIONS_SUCCESS = 'OPTIONS_SUCCESS';
export const OPTIONS_FAILURE = 'OPTIONS_FAILURE';
export const OPEN_TERM_REQUEST = 'OPEN_TERM_REQUEST';
export const OPEN_TERM_SUCCESS = 'OPEN_TERM_SUCCESS';
export const OPEN_TERM_FAILURE = 'OPEN_TERM_FAILURE';
export const ADD_ALERT = 'ADD_ALERT';
export const REMOVE_ALERT = 'REMOVE_ALERT';
export const SET_USER = 'SET_USER';
export const AUTH_USER = 'AUTH_USER';
export const UPDATE_BASIC_INFO = 'UPDATE_BASIC_INFO';
export const UPDATE_NAME = 'UPDATE_NAME';
export const UPDATE_CONFIRMATION = 'UPDATE_CONFIRMATION';
export const FETCH_DELTA_ID = 'FETCH_DELTA_ID';

// Form Actions
export const SET_STEP = 'SET_STEP';
export const TOGGLE_SUBMITTED = 'TOGGLE_SUBMITTED';

// Used for first time users while account is set up
export const SET_NEW_USER = 'SET_NEW_USER';
export const UNSET_NEW_USER = 'UNSET_NEW_USER';

// Application Actions
export const TOGGLE_CONFIRMATION = 'TOGGLE_CONFIRMATION';
export const SUBMIT_APPLICATION_REQUEST = 'SUBMIT_APPLICATION_REQUEST';
export const SUBMIT_APPLICATION_SUCCESS = 'SUBMIT_APPLICATION_SUCCESS';
export const SUBMIT_APPLICATION_FAILURE = 'SUBMIT_APPLICATION_FAILURE';
export const FETCH_APPLICATION_REQUEST = 'FETCH_APPLICATION_REQUEST';
export const FETCH_APPLICATION_SUCCESS = 'FETCH_APPLICATION_SUCCESS';
export const FETCH_APPLICATION_FAILURE = 'FETCH_APPLICATION_FAILURE';
export const APPLICATION_DOES_NOT_EXIST = 'APPLICATION_DOES_NOT_EXIST';

// Education Information Actions
export const ADD_COLLEGE = 'ADD_COLLEGE';
export const UPDATE_COLLEGE = 'UPDATE_COLLEGE';
export const REMOVE_COLLEGE = 'REMOVE_COLLEGE';
export const ADD_DEGREE = 'ADD_DEGREE';
export const REMOVE_DEGREE = 'REMOVE_DEGREE';
export const UPDATE_DEGREE = 'UPDATE_DEGREE';
export const UPDATE_APPLICATION = 'UPDATE_APPLICATION';

// Other Information Actions
export const UPDATE_OTHER_INFO = 'UPDATE_OTHER_INFO';
export const TOGGLE_LIFE_CIRCUMSTANCES = 'TOGGLE_LIFE_CIRCUMSTANCES';
export const UPDATE_TEAS = 'UPDATE_TEAS';

// Auth Actions - Okta
export const AUTH_REQUEST = 'AUTH_REQUEST';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAILURE = 'AUTH_FAILURE';

// Auth Actions - AWS
export const CREDENTIALS_REQUEST = 'CREDENTIALS_REQUEST';
export const CREDENTIALS_SUCCESS = 'CREDENTIALS_SUCCESS';
export const CREDENTIALS_FAILURE = 'CREDENTIALS_FAILURE';

// Auth Actions - UI
export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_FAILURE = 'LOGOUT_FAILURE';


// API Actions
export const FETCH_USER_REQUEST = 'FETCH_USER_REQUEST';
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS';
export const FETCH_USER_FAILURE = 'FETCH_USER_FAILURE';
export const USER_NOT_FOUND = 'USER_NOT_FOUND';
export const CREATE_USER_REQUEST = 'CREATE_USER_REQUEST';
export const CREATE_USER_SUCCESS = 'CREATE_USER_SUCCESS';
export const CREATE_USER_FAILURE = 'CREATE_USER_FAILURE';
export const CREATE_APPLICATION_REQUEST = 'CREATE_APPLICATION_REQUEST';
export const CREATE_APPLICATION_SUCCESS = 'CREATE_APPLICATION_SUCCESS';
export const CREATE_APPLICATION_FAILURE = 'CREATE_APPLICATION_FAILURE';
export const UPDATE_APPLICATION_REQUEST = 'UPDATE_APPLICATION_REQUEST';
export const UPDATE_APPLICATION_SUCCESS = 'UPDATE_APPLICATION_SUCCESS';
export const UPDATE_APPLICATION_FAILURE = 'UPDATE_APPLICATION_FAILURE';